import { render, staticRenderFns } from "./form-time.vue?vue&type=template&id=c00cb49a&scoped=true"
import script from "./form-time.ts?vue&type=script&lang=ts&external"
export * from "./form-time.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00cb49a",
  null
  
)

export default component.exports